import { DataResponse } from './Validator';
import { PaginatedResponse } from './Deploy';
import { AccountInfoResult } from './AccountInfo.ts';

export interface BlockResult {
  block_hash: string;
  block_height: number;
  contract_calls_number: number;
  era_id: number;
  is_switch_block: boolean;
  native_transfers_number: number;
  parent_block_hash: string;
  proposer_account_info?: AccountInfoResult | null;
  proposer_centralized_account_info?: AccountInfoResult | null;
  proposer_public_key: string;
  state_root_hash: string;
  timestamp: string;
}

export interface BlockResult {
  blockHash: string;
  blockHeight: number;
  contractCallsNumber: number;
  eraId: number;
  isSwitchBlock: boolean;
  transferCount: number;
  parentHash: string;
  proposerPublicKey: string;
  proposerAccountInfo?: AccountInfoResult | null;
  proposerCentralizedAccountInfo?: AccountInfoResult | null;
  stateRootHash: string;
  timestamp: string;
}

export function Block(obj: any): BlockResult {
  return obj;
}

export const MapBlock = ({
  block_hash,
  block_height,
  contract_calls_number,
  era_id,
  is_switch_block,
  native_transfers_number,
  parent_block_hash,
  proposer_account_info,
  proposer_centralized_account_info,
  proposer_public_key,
  state_root_hash,
  timestamp,
  ...rest
}: BlockResult): BlockResult => ({
  ...rest,
  timestamp,
  blockHash: block_hash,
  blockHeight: block_height,
  eraId: era_id,
  transferCount: native_transfers_number,
  parentHash: parent_block_hash,
  stateRootHash: state_root_hash,
  contractCallsNumber: contract_calls_number,
  isSwitchBlock: is_switch_block,
  proposerPublicKey: proposer_public_key,
  proposerAccountInfo: proposer_account_info,
  proposerCentralizedAccountInfo: proposer_centralized_account_info,
});

export const MapPaginatedBlocks = ({
  data,
  ...rest
}: PaginatedResponse<BlockResult>): PaginatedResponse<BlockResult> => ({
  ...rest,
  data: data ? data.map(MapBlock) : [],
});

export const MapPaginatedBlock = ({
  data,
  ...rest
}: DataResponse<BlockResult>): BlockResult => ({
  ...MapBlock(data),
});
